import { cloneDeep, isFunction } from 'lodash';

export const showColumn = (column: Recordable) => {
  if (column.render) {
    return false;
  }
  if (
    column.formatter &&
    !(column.showTooltip && isFunction(column.formatter))
  ) {
    // formatter和showTooltip同时存在时使用template渲染，并且formatter必须是函数
    return false;
  }
  return true;
};

// 图片使用width，当表格又剩余宽度时不等比例放大
export const getColumnWidth = (column: Recordable) => {
  if ((column.useWidth || column?.type === 'image') && column?.width)
    return column.width;
  return undefined;
};

// 滚动要指定列（减去固定列
export const scrollToColumnByField = (
  tableRef: any,
  columns: Recordable,
  field: string
) => {
  try {
    if (!tableRef || !columns?.length || !field) return;
    const column = tableRef?.getColumnByField(field);
    const tdElem = tableRef?.$el?.querySelector('.'.concat(column?.id));
    if (!tdElem) return;
    const leftFixedWidth = columns
      .filter((item: Recordable) => item.fixed === 'left')
      .reduce((total: number, item: any) => {
        if (item.fixed === 'left') {
          total += item.width || 120;
        }
        return total;
      }, 0);
    // 减掉左侧固定列宽
    tableRef.scrollTo(tdElem.offsetLeft - leftFixedWidth);
  } catch (error) {
    console.error(error);
  }
};

// 将右固定的列移到最后面，保证表尾数据位置正确
export const handleFixedRightCols = (columns: Recordable[]) => {
  const cols: Recordable[] = [];
  const rightCols: Recordable[] = [];
  columns.forEach((column: Recordable) => {
    if (column.fixed === 'right') {
      rightCols.push(column);
    } else {
      cols.push(column);
    }
  });
  return [...cols, ...rightCols];
};

export const formatterField = (...rest: any[]) => {
  const { column, row } = rest[0];
  const { formatterFunc } = column;
  if (formatterFunc && isFunction(formatterFunc)) {
    return formatterFunc(...rest);
  }
  return `${column.prefix ?? ''}${row[column.field] ?? column.default ?? ''}${
    column.suffix ?? ''
  }`;
};

/**
 * 用于删除vxe-table中row的唯一键，删除后将在渲染当前行时重新执行formatter，而不使用唯一键缓存
 * 对应vxe-table中fullAllDataRowIdData[rowid].formatData
 * @param row 要重新执行formatter的行
 */
export const removeRowUniqueKey = (row?: Recordable) => {
  if (!row) return;
  const rowKeyField = '_X_ROW_KEY';
  delete row[rowKeyField]; // 去除唯一key
};

// 删除数组中表格的唯一值，并且返回一个新数组，不改变原数组
export const removeTableUniqueKey = (list: Recordable[]) => {
  return cloneDeep(list).map((row: Recordable) => {
    removeRowUniqueKey(row);
    delete row.uuid;
    return row;
  });
};
